import { Component } from "@angular/core";
import { fadeInOutAnimation } from "@app/animations";


@Component({
    template: `
    <div class="body-wrapper">    
      <div class="text-center layer-overlay">
      <img class="loading-logo" src="/platform/assets/img/loading-logo.gif" />
      </div>
    </div>
    `,
    // animations: [fadeInOutAnimation]
  })
  

export class LoadingComponent {
}
